import logo from './logo.svg';
import './App.css';
import Homepage from './Homepage.jsx';

function App() {
  return (
  <Homepage/>
  );
}

export default App;
